import React, { FC, useState } from 'react';
import { BLACKS_AND_WHITES, optionalFilter } from '../../utils/DataFormatterUtils';
import {
	getPrimaryColor,
	getWorkOrderTimeZoneId,
	nullSafeGet,
	nullSafeGetOrElse,
} from '../../utils/DataAccessUtils';
import { INVOICE_STATUS_DISPLAY_NAMES } from '../../constants/InvoiceStatuses';
import DetailRow from '../detail_row/DetailRow';
import LocationName from '../name_component/location/LocationNameComponent';
import OWLink from '../OWLink';
import { getWorkOrderPath } from '../../utils/WorkOrderUtils';
import { Row } from 'antd';
import DateTimeHover from '../date_time_component/DateTime';
import {
	getInvoiceOtherCompany,
	getInvoiceSubmittedAt,
	getInvoiceSubmittedContact,
} from '../invoice_utilities/InvoiceUtilities';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { UserName } from '../name_component/user/UserNameComponent';

const dateFormat = 'MMM D, YYYY';

const InvoicesAdditionalDetails: FC<any> = ({
	invoice,
	lastInvoice = {},
	contactType = 'buyer',
	passthroughItems = [],
	userType,
	currentUser,
	showComparison,
}): React.ReactElement => {
	const [showAll, setShowAll] = useState(false);
	const submittedContact = getInvoiceSubmittedContact(invoice);
	const submittedTime = getInvoiceSubmittedAt(invoice);
	const workOrderIdForLink =
		nullSafeGet('workOrderId', invoice) || nullSafeGet('workOrder.id', invoice);
	const detailItems = [
		{ key: 'Status', value: INVOICE_STATUS_DISPLAY_NAMES[invoice.status] },
		{
			key: 'Work Order #',
			value: workOrderIdForLink ? (
				<OWLink
					preserveBackLinkStates={true}
					backText="Back to invoice"
					to={`/${userType}/workOrders/detail/${workOrderIdForLink}/${getWorkOrderPath(
						userType,
						currentUser,
						invoice
					)}details`}
				>
					{workOrderIdForLink}
				</OWLink>
			) : (
				optionalFilter(null)
			),
		},
		{
			key: 'Location',
			value: nullSafeGet('workOrder.location', invoice) ? (
				<LocationName
					location={nullSafeGet('workOrder.location', invoice)}
					mode="container"
					underline
					placement="top"
				/>
			) : null,
		},
		{
			key: 'Invoice #',
			value: optionalFilter(nullSafeGet('invoiceNumber', invoice)),
		},
		{
			key: 'Payment Terms',
			value: optionalFilter(invoice.paymentTerms),
		},
		{
			key: 'Invoice Date',
			value: nullSafeGet('dateOfInvoice', invoice) ? (
				<DateTimeHover
					timestamp={nullSafeGet('dateOfInvoice', invoice)}
					showDate={true}
					showTime={false}
					timeZone={getWorkOrderTimeZoneId(nullSafeGet('workOrder', invoice))}
				/>
			) : (
				'--'
			),
		},
		{
			key: 'Due Date',
			value: (
				<DateTimeHover
					timestamp={nullSafeGet('dueDate', invoice)}
					showDate={true}
					showTime={false}
					timeZone={getWorkOrderTimeZoneId(nullSafeGet('workOrder', invoice))}
				/>
			),
		},
		{
			key: 'Submitted By Company',
			value:
				nullSafeGet('isBuyerUploaded', invoice) || false
					? nullSafeGet('workOrder.buyerCompany.displayName', invoice)
					: nullSafeGet('workOrder.supplierFacility.displayName', invoice),
		},
		submittedContact
			? {
					key: 'Submitted By',
					value: <UserName contact={submittedContact} mode={'inline'} placement={'top'} />,
			  }
			: {},
		submittedTime
			? {
					key: 'Submitted On',
					value: (
						<DateTimeHover
							timestamp={submittedTime}
							showDate={true}
							showTime={false}
							timeZone={getWorkOrderTimeZoneId(nullSafeGet('workOrder', invoice))}
						/>
					),
			  }
			: {},
		...passthroughItems,
	];

	return (
		<div
			style={{
				display: 'flex',
				flexDirection: 'column',
				gap: 20,
				width: '100%',
			}}
		>
			<Row>{getInvoiceOtherCompany(invoice, currentUser)}</Row>
			{nullSafeGetOrElse('scope.length', lastInvoice, 0) > 0 &&
			nullSafeGet('scope', invoice) !== nullSafeGet('scope', lastInvoice) &&
			showComparison ? (
				<div style={{ padding: 0 }} className="materialCard__body">
					<div className="materialCard__primaryTitle">
						<div
							style={{
								fontSize: 16,
								textDecoration: 'line-through',
								color: BLACKS_AND_WHITES.blackSecondary,
								...(showAll
									? {}
									: {
											display: '-webkit-box',
											WebkitLineClamp: 5,
											WebkitBoxOrient: 'vertical',
											overflow: 'hidden',
									  }),
							}}
							className="richTextWrapper"
							dangerouslySetInnerHTML={{ __html: lastInvoice.scope }}
						/>
						<span
							style={{
								color: getPrimaryColor(userType),
								cursor: 'pointer',
							}}
							onClick={() => setShowAll(!showAll)}
						>
							{showAll ? 'Show Less' : 'Show More'}
						</span>
					</div>
				</div>
			) : null}
			{nullSafeGet('scope', invoice) ? (
				<div style={{ padding: 0 }} className="materialCard__body">
					<div className="materialCard__primaryTitle">
						<div
							style={{ fontSize: 16 }}
							className="richTextWrapper"
							dangerouslySetInnerHTML={{ __html: invoice.scope }}
						/>
					</div>
				</div>
			) : null}
			<DetailRow details={detailItems} />
		</div>
	);
};
const mapStateToProps = (state) => ({
	currentUser: state.session.currentUser,
});

const mapDispatchToProps = (dispatch, ownProps) => ({});

const ComponentWithoutUserType = withRouter(
	connect(mapStateToProps, mapDispatchToProps)(InvoicesAdditionalDetails)
);

export default connect(
	(state) => ({
		userType: (state as any).session.userType,
	}),
	() => ({})
)(ComponentWithoutUserType);
